import {API_DRIVER} from "../config/axios";

const getContactsRequestUrl = (endpointUrl: string) => {
    return `/api/contacts${endpointUrl}`
}

export interface IContactCreate {
    name: string
    email: string
    message: string
}

export interface IContactResponded {
    responded: boolean
}

const ContactService = {
    fetchContacts: (page: number, size: number) => {
        return API_DRIVER.get(getContactsRequestUrl(``), {
            params: {
                limit: size,
                offset: page,
            }
        })
    },
    fetchContactById: (id: string) => {
        return API_DRIVER.get(getContactsRequestUrl(`/${id}`))
    },
    createContact: (body: IContactCreate) => {
        return API_DRIVER.post(getContactsRequestUrl(``), body)
    },
    deleteContact: (id: string) => {
        return API_DRIVER.delete(getContactsRequestUrl(`/${id}`))
    },
    updateContactResponded: (id: string, body: IContactResponded) => {
        return API_DRIVER.put(getContactsRequestUrl(`/update-responded/${id}`), body)
    },
}

export default ContactService
